import React from 'react';

import Textbox, { TextboxProps } from 'carbon-react/lib/components/textbox';

import { ForecastFormElementIds } from './types';

export type ForecastNameProps = Omit<TextboxProps, 'name' | 'id'>;

export const ForecastName = (props: ForecastNameProps) => {
  return <Textbox name={ForecastFormElementIds.Name} id={ForecastFormElementIds.Name} required {...props} />;
};
